// extracted by mini-css-extract-plugin
export var fadeIn = "_ga-1";
export var modalContent = "_ga-3";
export var overlay = "_ga-0";
export var popoverContent = "_ga-2";
export var results = "_ga-5";
export var searchInputWrapper = "_ga-4";